import { motion } from "framer-motion";

const FooterLinks = () => {
  return (
    <motion.div
      initial={{ x: 20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 2.2, duration: 0.5 }}
      className="flex items-center space-x-4"
    >
      <a href="#" className="text-white hover:text-gray-400">
        Privacy Policy
      </a>
      <a href="#" className="text-white hover:text-gray-400">
        Terms of Use
      </a>
    </motion.div>
  );
};

export default FooterLinks;
